import React from 'react'
import {useTranslation} from "react-i18next";
import Input from "./Input";
import PhoneNumber from "./PhoneNumber";

function GuestInput(props) {
  const {t} = useTranslation();

  return (
    <div className="columns">
      <div className="column">
        <Input label={t('first_name')} formField={props.firstName}
               value={props.firstNameValue}
               disabled={props.disabled}/>
      </div>
      <div className="column">
        <Input label={t('last_name')} formField={props.lastName}
               value={props.lastNameValue}
               disabled={props.disabled}/>
      </div>
      <div className="column">
        <PhoneNumber label={t('mobile_number')} formField={props.mobileNumber}
                     value={props.mobileNumberValue}
                     disabled={props.disabled}/>
      </div>
      <div className="column">
        <Input label={t('email')} formField={props.email}
               value={props.emailValue}
               disabled={props.disabled}/>
      </div>
    </div>
  );
}

export default GuestInput;
